import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Phone, MapPin, Clock } from 'lucide-react';

const OrderingDisabled = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-20">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto text-center">
          <div className="bg-yellow-100 border-2 border-yellow-400 rounded-2xl p-8 mb-8">
            <h1 className="text-3xl lg:text-4xl font-black text-gray-900 mb-4">
              Online Ordering Temporarily Unavailable
            </h1>
            <p className="text-xl text-gray-600 mb-6">
              We're currently not accepting online orders. Please visit us in store or call to place your order.
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 space-y-6">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">How to Order</h2>
            
            <div className="flex items-center justify-center space-x-4 text-lg">
              <Phone className="h-6 w-6 text-red-600" />
              <a href="tel:01onal616524" className="text-red-600 font-bold hover:underline">
                Call Us: 0161 843 2233
              </a>
            </div>

            <div className="flex items-center justify-center space-x-4 text-lg">
              <MapPin className="h-6 w-6 text-red-600" />
              <span className="text-gray-700">
                173 Yorkshire Street, Oldham, OL1 3TZ
              </span>
            </div>

            <div className="flex items-center justify-center space-x-4 text-lg">
              <Clock className="h-6 w-6 text-red-600" />
              <span className="text-gray-700">
                Mon-Sun: 12:00 PM - 11:00 PM
              </span>
            </div>

            <div className="pt-6">
              <Link to="/menu">
                <Button
                  size="lg"
                  className="bg-red-600 hover:bg-red-700 text-white font-bold px-8 py-6 rounded-full"
                >
                  VIEW OUR MENU
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderingDisabled;
